import { DateField, useRecordContext } from "react-admin";
import { hmLightTheme } from "../themes/hmTheme";
import { Typography } from "@mui/material";
import formatDate from "./formatDate";

const CustomDateField = ({ ...props }) => {
  const { source, onlyShowDate, oldFormat, ...dateFieldProps } = props;
  const record = useRecordContext();
  if (!record) return null;

  const date = record[source] ? record[source] : null;
  if (
    date == "" ||
    date == null ||
    date == "0000-00-00" ||
    date == "0000-00-00 00:00:00"
  )
    return null;

  if (oldFormat == "mm-dd-yyyy") {
    const date = record[source] ? record[source] : null;
    //change to yyyy-mm-dd
    return (
      <Typography sx={{ verticalAlign: "middle", alignItems: "center" }}>
        {date
          ? date.substring(6, 10) +
            "-" +
            date.substring(0, 2) +
            "-" +
            date.substring(3, 5)
          : null}
      </Typography>
    );
  }
  if (onlyShowDate) {
    const date = record[source] ? record[source] : null;
    return <>{date ? date.substring(0, 10) : null}</>;
  } else {
    return (
      <DateField
        className="numberFontFamily hm-text"
        {...dateFieldProps}
        source={source}
        showTime
        locales="zh-CN"
        transform={(value) => value && value.replace(/\//g, "-")}
        sx={{
          fontFamily: hmLightTheme?.palette?.numberFontFamily,
          verticalAlign: "middle",
          alignItems: "center",
        }}
      />
    );
  }
  // record[source] = record[source] ? record[source] : record[source].replace(/\//g, '-');
  // const date = record[source];
  // return date;

  // const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
  // const formatter = new Intl.DateTimeFormat('zh-CN', options);

  // if (!date) {
  //     return <span>-</span>;
  // }
  // return <span>{formatter.format(new Date(date))}</span>;
};

export default CustomDateField;
